/**
 * Private partner perk: the seller's "Powered by Checkout Page" badges link
 * through their Rewardful affiliate URL. Returns the `via` token when the perk
 * is active (enabled AND non-empty token), else null. Mirrored in
 * apps/api/src/sellers/feature-access/resolveAffiliateBadgeToken.js and
 * packages/plugin-core/src/partnerRef.ts — keep in sync.
 */
export default function resolveAffiliateBadgeToken(seller) {
  const affiliateBadge = seller?.affiliateBadge;
  if (!affiliateBadge?.enabled) return null;
  const token = typeof affiliateBadge.token === 'string' ? affiliateBadge.token.trim() : '';
  return token || null;
}
